import { render, staticRenderFns } from "./selectusers.vue?vue&type=template&id=3f2735a5&"
import script from "./selectusers.vue?vue&type=script&lang=ts&"
export * from "./selectusers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports